import util from '@/js/Util'

function devices(state) {
  return state.cube.devices
}

function devicesLoaded(state) {
  return state.cube.devicesLoaded
}

function deviceById(state) {
  return (deviceId) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    return state.cube.devices[deviceIndex]
  }
}

function deviceTimerSlots() {
  return (device) => device.timer.slots
}

function deviceSelectedTimerSlot() {
  return (device) => device.timer.selectedIndex
}

function applianceTypes(state) {
  return Object.entries(state.cube.applianceTypes)
}

function deviceReadsData(state) {
  return (deviceId) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    return state.cube.devices[deviceIndex].reads
  }
}

function deviceConsumptionTimespans(state) {
  return state.cube.deviceConsumptionTimespans
}

function deviceTimeSlotsForDay(state) {
  return (deviceId, day) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    return state.cube.devices[deviceIndex].timer[day]
  }
}

function deviceCanAddTimeSlot(state) {
  return (deviceId, day) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    const slots = state.cube.devices[deviceIndex].timer[day]
    return util.canAddDeviceTimeSlot(slots[slots.length - 1].end)
  }
}

function deviceTimeSlotsAreValidForAllDays(state) {
  return (deviceId) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    return state.cube.devices[deviceIndex].timer.setForAllDays
  }
}
function deviceTimerChanged(state) {
  return (deviceId) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    return state.cube.devices[deviceIndex].timer.changed
  }
}

function deviceTimerIsActive(state) {
  return (deviceId) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    return state.cube.devices[deviceIndex].timer.active
  }
}

function deviceTimerSettingsForBackend(state) {
  return (deviceId) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    const timer = state.cube.devices[deviceIndex].timer

    let result = {
      manual_time_slots_mon_: '',
      manual_time_slots_tue_: '',
      manual_time_slots_wed_: '',
      manual_time_slots_thu_: '',
      manual_time_slots_fri_: '',
      manual_time_slots_sat_: '',
      manual_time_slots_sun_: '',
    }

    if (timer.setForAllDays) {
      const values = util.stringifyTimeSlots(timer.all)
      result['manual_time_slots_mon_'] = values
      result['manual_time_slots_tue_'] = values
      result['manual_time_slots_wed_'] = values
      result['manual_time_slots_thu_'] = values
      result['manual_time_slots_fri_'] = values
      result['manual_time_slots_sat_'] = values
      result['manual_time_slots_sun_'] = values
    } else {
      result['manual_time_slots_mon_'] = util.stringifyTimeSlots(timer.monday)
      result['manual_time_slots_tue_'] = util.stringifyTimeSlots(timer.tuesday)
      result['manual_time_slots_wed_'] = util.stringifyTimeSlots(
        timer.wednesday
      )
      result['manual_time_slots_thu_'] = util.stringifyTimeSlots(timer.thursday)
      result['manual_time_slots_fri_'] = util.stringifyTimeSlots(timer.friday)
      result['manual_time_slots_sat_'] = util.stringifyTimeSlots(timer.saturday)
      result['manual_time_slots_sun_'] = util.stringifyTimeSlots(timer.sunday)
    }

    return result
  }
}

function showDeleteDevicePopup(state) {
  return state.cube.showDeleteDevicePopup
}

function deviceConsumption(state) {
  return (deviceId) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    return state.cube.devices[deviceIndex].consumption
  }
}

function deviceIsOnChangedLocally(state) {
  return (deviceId) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    return state.cube.devices[deviceIndex].isOnChangedLocally
  }
}

function deviceTimeSlotsAreValid(state) {
  return (deviceId) => {
    const deviceIndex = util.getDeviceIndex(state, deviceId)
    return state.cube.devices[deviceIndex].timer.isValid
  }
}

export default {
  devicesLoaded,
  devices,
  deviceById,
  deviceTimerSlots,
  deviceSelectedTimerSlot,
  applianceTypes,
  deviceReadsData,
  deviceConsumptionTimespans,
  deviceTimeSlotsForDay,
  deviceCanAddTimeSlot,
  deviceTimeSlotsAreValidForAllDays,
  deviceTimerChanged,
  deviceTimerIsActive,
  deviceTimerSettingsForBackend,
  deviceTimeSlotsAreValid,
  showDeleteDevicePopup,
  deviceConsumption,
  deviceIsOnChangedLocally,
}
